<template>
  <div class="container">
    <FormContainer v-if="success !== true" class="row" @submitForm="getChangePasswordToken">
      <div class="col-12 mb-2">
        <router-link :to="{ name: 'login' }">
          <i class="fas fa-chevron-left mr-1"></i> Torna al login
        </router-link>
      </div>

      <div v-if="success === false" class="col-12 mt-2">
        <FormErrors>
          <Alert status="danger" class="m-0">
            Si è verificato un errore non previsto, si prega di riprovare
          </Alert>
        </FormErrors>
      </div>

      <FormInputTextWidget
        class="col-12"
        label="Email"
        placeholder="example@email.com"
        v-model="email"
        :errorMsg="errorHash.email"
        type="email"
        @input="removeError('email')"
      />
      <div class="col-12 mt-4">
        <button class="btn btn-primary" type="submit">Reset</button>
      </div>
    </FormContainer>
    <template v-else>
      <p class="feedback text-center">
        Ti abbiamo spedito una email all'indirizzo <b>{{email}}</b>
      </p>
      <div class="text-center">
        <router-link :to="{ name: 'login' }" class="btn btn-outline-primary">
          Torna al login
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>
import validateMixin from '../../../libs/Form/mixins/validate';

export default {
  name: 'password-reset',
  data () {
    return {
      email: this.$route.params.email || null,
      success: null,
    };
  },
  components: {
    FormInputTextWidget: () => import('../../../libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormContainer: () => import('../../../libs/Form/components/FormContainer'),
    FormErrors: () => import('../../../libs/Form/components/FormErrors'),
    Alert: () => import('../../../libs/Feedback/components/Alert'),
  },
  mixins: [validateMixin],
  methods: {
    showFinalMessage () {
      this.success = true;
    },
    notifyError () {
      this.success = false;
    },
    getChangePasswordToken () {
      if (!this.isValid()) {
        return;
      }

      this.$api.getChangePasswordToken(this.email).then(
        this.showFinalMessage,
        this.notifyError,
      ).catch(this.notifyError);
    },
    isValid () {
      if (!this.validateEmail(this.email)) {
        this.addError('Indirizzo email non valido', 'email');
      }

      return !this.hasErrors;
    },
    validateEmail (email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
  },
};

</script>
